<template>
  <div class="py-8 px-9">
    <StudentAttendanceDataTable />
  </div>
</template>

<script>
import StudentAttendanceDataTable from "@/components/Utils/StudentAttendanceDataTable.vue";
export default {
  components: {
    StudentAttendanceDataTable,
  },
  created() {
    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.render = true;
      this.$router.push("/");
    }
  },
  data: () => ({
    typeData: [],
    action: null,
    reload: false,
  }),
  methods: {},
};
</script>

<style></style>
